export default function Rust() {
  return (
    <div>
      <h1>Rust Component</h1>
      <p>This is the Rust page.</p>
    </div>
  );
}
